import 'css-chunksrc/client/pages/projectPage/discussionsPage/discussions/discussion/loader/styles.scss';export default {
  "comment": "_comment_415rq_1",
  "avatar": "_avatar_415rq_12",
  "main": "_main_415rq_19"
};